<script>
import { ArrowUpIcon } from 'vue-feather-icons';

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

export default {
    data() {
        return {}
    },
    components: {
        Navbar,
        Footer,
        ArrowUpIcon
    }
}
</script>

<template>
<div>
    <Navbar />

    <!-- Hero Start -->
    <section class="bg-half-170 bg-light d-table w-100">
        <div class="container">
            <div class="row mt-5 justify-content-center">
                <div class="col-lg-12 text-center">
                    <div class="pages-heading">
                        <h2 class="title mb-0">Konica Minolta Products & Solutions</h2>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="position-relative">
        <div class="shape overflow-hidden text-white">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
            </svg>
        </div>
    </div>
    <!-- Hero End -->

    <!-- Section 1: Multifuncionals Copiers - Two Columns -->
    <section class="section">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-4 col-md-5 text-center mb-4 mb-md-0">
                    <img src="/images/brands/konica.png" class="img-fluid" style="max-width: 200px;" alt="Konica Minolta Logo" />
                </div>
                <div class="col-lg-8 col-md-7">
                    <div class="section-title text-center text-md-left">
                        <h3 class="title mb-4">Multifuncionals Copiers</h3>
                        <p class="text-muted para-desc">
                            Konica Minolta has an amazing history to our exciting, current happenings. The more you learn about Konica Minolta, the more you'll see why they're a leader in innovation and our industry overall.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Section 2: Managed Print Services - Left Aligned -->
    <section class="section bg-light">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="section-title">
                        <h3 class="title mb-4">Managed Print Services</h3>
                        <p class="text-muted para-desc">
                            Konica Minolta’s Managed Print Services solution provides overall fleet management of your networked and local print devices. And because your business is not one-size-fits-all, Konica Minolta multifunctional strategically combine hardware, software implementation and workflow management to give you a solution that’s unique to your business. Helping you control operating costs, improve operations, and move your business forward.
                        </p>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div class="ml-lg-5">
                        <div class="card border-0 rounded shadow bg-white">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <i class="uil uil-cog h2 text-primary mb-0"></i>
                                    <h5 class="mb-0 ml-3">Fleet Management</h5>
                                </div>
                                <p class="text-muted mb-0">Control operating costs, improve operations, and move your business forward.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Section 3: Digital Embellishment - Right Aligned -->
    <section class="section">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div class="mr-lg-5">
                        <div class="card border-0 rounded shadow bg-light">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <i class="uil uil-star h2 text-primary mb-0"></i>
                                    <h5 class="mb-0 ml-3">High-Margin Capability</h5>
                                </div>
                                <p class="text-muted mb-0">Adding texture, shine, and dimension that customers notice.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 order-1 order-md-2">
                    <div class="section-title">
                        <h3 class="title mb-4">Digital Embellishment: A Profit Opportunity</h3>
                        <p class="text-muted para-desc mb-4">
                            In a crowded market, digital embellishment gives your prints the edge- adding texture, shine, and dimension that customers notice and are willing to pay more for. This high-margin capability not only enhances your output but also unlocks new revenue streams without major investments.
                        </p>
                    </div>
                </div>
            </div>

            <!-- CTA -->
            <div class="row justify-content-center mt-5">
                <div class="col-lg-10 text-center">
                    <router-link to="/contact-us" class="btn btn-primary">Contact Us for More Information</router-link>
                </div>
            </div>
        </div>
    </section>

    <Footer />
    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" v-scroll-to="'#topnav'">
        <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
</div>
</template>
